import OliverText from "@builder/components/general/OliverText";
import DynamicIcon from "@common/components/DynamicIcon";
import "./style.scss";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "@builder/store/store";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { closePopup } from "@builder/store/slices/popupSlice";
import { FINAL_ICON_LIBRARY } from "@common/utils/finalIconMap";

const getIcons = (limit: number, search?: string) => {
    const iconKeys = Object.keys(FINAL_ICON_LIBRARY);
    if (search) {
        const icons = [];
        const searchTerm = search.toLowerCase().replace(/\s+/g, '');

        for (let i = 0; i < iconKeys.length; i++) {
            const finalIcon = iconKeys[i].toLowerCase().replace(/\s+/g, '');
            if (finalIcon.includes(searchTerm)) {
                icons.push(iconKeys[i]);
            }
            if (icons.length === limit) {
                return icons;
            }
        }
        return icons;
    } else {
        return iconKeys.slice(0, limit);
    }
};

const getIconName = (iconName: string): string => {
    const splitName = iconName.split("-");
    const capitalized = splitName.map(string => string.charAt(0).toUpperCase() + string.slice(1));
    if (splitName.length === 1) {
        return capitalized[0];
    } else {
        if (Number.isNaN(parseInt(capitalized[capitalized.length - 1]))) {
            return capitalized.join(" ");
        } else {
            return capitalized.slice(0, -1).join(" ") + "-" + capitalized[capitalized.length - 1];
        }
    }
};

const FinalIconLibrary = ({ path, search }: { path?: (string | number)[]; search?: string }) => {
    const dispatch = useAppDispatch();
    const INCREMENT = 52;
    const [limit, setLimit] = useState<number>(52);
    const [currentGridItems, setCurrentGridItems] = useState<string[]>([]);
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setCurrentGridItems(getIcons(limit, search).sort());
    }, [limit]);

    useEffect(() => {
        if (limit !== INCREMENT) {
            setLimit(INCREMENT);
            if (scrollRef.current) {
                scrollRef.current.scrollTop = 0;
            }
        } else {
            setCurrentGridItems(getIcons(limit, search).sort());
        }
    }, [search]);

    const handleIconSelect = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: path ? [...path, "src"] : ["icon", "src"], value }));
        dispatch(updateNodeProperty({ propertyPath: path ? [...path, "colors"] : ["icon", "colors"], value: "", remove: true }));
        dispatch(closePopup());
    };

    const handleGridScroll = () => {
        const scrollElem = scrollRef.current;
        if (scrollElem) {
            if (scrollElem.scrollHeight - scrollElem.scrollTop < scrollElem.clientHeight + 5) {
                setLimit(limit + INCREMENT);
            }
        }
    };

    return (
        <div className="final-icon-library" ref={scrollRef} onScroll={handleGridScroll}>
            {currentGridItems.map((name, index) => (
                <button className="grid-icon" key={`name-${index}`} onClick={() => handleIconSelect(name)}>
                    <div className="icon-wrapper">
                        <DynamicIcon name={name} />
                    </div>
                    <OliverText text={getIconName(name)} size="xs" weight="medium-heavy" className="grid-item-text" />
                </button>
            ))}
        </div>
    );
};

export default FinalIconLibrary;
